import React, { Component } from 'react';

import { ModalBase } from 'ui/lexus/containers';

import Agreenment from './data';

export default class ModalAgreementOnReceivingEmails extends Component {
    componentDidMount() {
        document.querySelector('body').classList.add('overflow');
    }

    componentWillUnmount() {
        document.querySelector('body').classList.remove('overflow');
    }

    render() {
        const {
            onClose, name,
        } = this.props;

        return (
            <>
                <ModalBase
                    title="Согласие на получение информации о продуктах и услугах"
                    content={Agreenment}
                    onClose={onClose}
                    name={name}
                    task="toyota"
                />
            </>
        );
    }
}
